import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarStore {
  open: boolean;
  setOpen: (value: boolean | ((prev: boolean) => boolean)) => void;
}

export const useSidebarStore = create<SidebarStore>()(
  persist(
    (set) => ({
      open: true,
      setOpen: (value) =>
        set((state) => ({
          open:
            typeof value === "function" ? (value as (p: boolean) => boolean)(state.open) : value,
        })),
    }),
    {
      name: "sidebar_state",
      partialize: (state) => ({ open: state.open }),
    }
  )
);
